module.exports = __webpack_public_path__ + "4da5b0542da0f0dfd85cc075536374b8.png";